import Breadcrumb from "component/common/breadcrumb";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import usePermission from "utils/usePermission";
import { handleListResponse, seo } from "utils/utils";
import { getBookingList } from "../../reduxStore/action/bookingActions";
import TableDataNotFound from "component/TableDataNotFound";
import usePage from "utils/usePage";
import moment from "moment";
import { bookingStatus, bookingStatusColor } from "../../utils/constants";
import Pagination from "component/common/Pagination";
import { getReportPropertyList } from "reduxStore/action/reportActions";
import { getAgentProperty } from "reduxStore/action/propertyActions";
import Select from "react-select";

const CancelBookingList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = usePage();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const [propertyList, setPropertyList] = useState([]);
  const [bookingList, setBookingList] = useState([]);
  const ReportListSelector = useSelector((state) => state.report);
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const bookingListSelector = useSelector((state) => state?.booking);
  const propertySelector = useSelector((state) => state.propertyData);
  const { isAdmin } = usePermission({});


  const [form, setForm] = useState({
    start_date: "",
    end_date: "",
    limit: "",
    offset: "",
    booking_status: 4,
    property_name: "",
    customer_name: ""
  });

 useEffect(() => {
     dispatch(getAgentProperty({ offset: 0, limit: "" }));
   }, [dispatch]);
 
   useEffect(() => {
     if (isAdmin) {
       const { reportPropertyList } = ReportListSelector;
       if (reportPropertyList) {
         if (reportPropertyList?.status === 200) {
           setPropertyList(handleListResponse(reportPropertyList.data));
         } else {
           setPropertyList([]);
         }
       }
     }
   }, [ReportListSelector]);
 
   useEffect(() => {
     if (propertySelector.response) {
       if (
         propertySelector?.response &&
         propertySelector?.response.status === 200
       ) {
         const filteredData = propertySelector?.response?.data?.filter(
           (item) => item.status === true
         );
         if (filteredData?.length > 0) {
           setPropertyList(handleListResponse(filteredData));
         } else {
           setPropertyList([]); // Clear the list if no valid data
         }
       } else {
         setPropertyList([]);
       }
     }
   }, [dispatch, propertySelector]);

  useEffect(() => {
    if (bookingListSelector?.response?.status === 200) {
      if (bookingListSelector?.response?.data?.length > 0) {
        setBookingList(handleListResponse(bookingListSelector?.response?.data));
      }
    } else {
      setBookingList([]);
    }
  }, [bookingListSelector]);

  useEffect(() => {
    dispatch(getBookingList({ limit: 10, offset: page, booking_status: 4 }));
  }, [getBookingList]);

  const filterDetail = () => {
    if (!handleValid()) {
      dispatch(
        getBookingList({
          limit: 10,
          offset: 0,
          start_date: form.start_date,
          end_date: form.end_date,
          booking_status: 4,
          property_name: form?.site?.property_title,
          customer_name: form.customer_name
        })
      );
      setPage(0);
    }
  };

  const filterReset = () => {
    setForm({
      start_date: "",
      end_date: "",
      booking_status: 4,
      property_name: "",
      site: "",
      customer_name: ""
    });
    setFormVaild({
      ...formVaild,
      end_date: "",
    });
    dispatch(getBookingList({ limit: 10, offset: 0, booking_status: 4 }));
    setPage(0);
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;
    if (form.start_date !== "") {
      if (form.end_date === "") {
        formError = true;
        err["end_date"] = strings.endDateErr;
      }
    }
    setFormVaild(err);
    return formError;
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    if (e.target.name === "end_date") {
      setFormVaild({
        ...formVaild,
        end_date: "",
      });
    }
  };

  const handlePageClick = (newOffset) => {
    setPage(newOffset);
    dispatch(
      getBookingList({
        limit: 10,
        offset: newOffset,
        start_date: form.start_date,
        end_date: form.end_date,
        booking_status: 4,
        property_name: form?.site?.property_title,
        customer_name: form.customer_name
      })
    );
  };

  // Disable end_date
  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  useEffect(() => {
    seo({
      title: "Booking Listing",
      metaDescription: "Booking list",
      canonicalLink: window.location.href,
    });
  }, []);

  const { view } = usePermission({ view: "view_booking" });
  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.booking}
        titleactive={strings.bookingListing}
      />
      <div className="container-fluid">
        <div className="row">
          <div className="col-sm-12">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form className="theme-form">
                      <div className="row">
                        <div className="col-md-4">
                          <span className="cardText">{strings.startDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              data-target="#dt-date"
                              name="start_date"
                              value={form.start_date}
                              onChange={handleInputField}
                              min={form.start_date}
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">{strings.endDate}</span>
                          <div
                            className="input-group date"
                            id="dt-date"
                            data-target-input="nearest"
                          >
                            <input
                              className="form-control datetimepicker-input digits"
                              type="date"
                              name="end_date"
                              value={form.end_date}
                              onChange={handleInputField}
                              min={form.start_date}
                              // max={form.end_date}
                              disabled={endDateDisable}
                            />
                          </div>
                          {formVaild.end_date && (
                            <span style={{ color: "red" }}>
                              {formVaild.end_date}
                            </span>
                          )}
                        </div>
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByVisitorName}
                          </span>
                          <input
                            className="form-control datetimepicker-input digits"
                            type="text"
                            autoComplete="off"
                            placeholder={strings.searchVisitorName}
                            name="customer_name"
                            value={form.customer_name}
                            onChange={handleInputField}
                          />
                        </div>
                      </div>
                      <div className="row pt-3">
                        <div className="col-md-4">
                          <span className="cardText">
                            {strings.searchByPropertyName}
                          </span>
                          <Select
                            isSearchable
                            isClearable
                            onInputChange={(e) => {
                              if (isAdmin) {
                                if (e.length > 1) {
                                  dispatch(
                                    getReportPropertyList({
                                      search_site: e,
                                      isLoadMore: true,
                                    })
                                  );
                                } else {
                                  dispatch(
                                    getReportPropertyList({
                                      limit: 10,
                                      offset: 0,
                                      isLoadMore: true,
                                    })
                                  );
                                }
                              }
                            }}
                            placeholder={strings.searchByPropertyName}
                            options={propertyList}
                            getOptionLabel={(option) =>
                              `${option.property_title}`
                            }
                            getOptionValue={(option) => option._id}
                            name="site"
                            value={form.site}
                            onChange={(e) => {
                              setForm({ ...form, site: e });
                            }}
                          />
                        </div>
                        <div className="col-md-8 pt-4 ">
                          <div className="form-group d-flex justify-content-end">
                            <button
                              className="btn btn-warning mr-4"
                              type="button"
                              onClick={filterDetail}
                            >
                              {strings.search}
                            </button>
                            <button
                              className="btn btn-dark"
                              type="button"
                              onClick={filterReset}
                            >
                              {strings.reset}
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-header">
                    <h5>{strings.bookingList}</h5>
                  </div>
                  <div className="table-responsive">
                    <table className="table table-border-horizontal">
                      <thead className="text-center">
                        <tr>
                          <th scope="col">{strings.propertyName}</th>
                          <th scope="col">{strings.bookingDate}</th>
                          <th scope="col">{strings.customerName}</th>
                          <th scope="col">{strings.configuration}</th>
                          <th scope="col">{strings.budget}</th>
                          <th scope="col">{strings.status}</th>
                          <th scope="col">{strings.action}</th>
                        </tr>
                      </thead>
                      <tbody className="text-center">
                        {bookingList?.length > 0 ? (
                          bookingList.map((item, index) => {
                            return (
                              <tr key={index}>
                                <td>{item.property_title}</td>
                                <td>
                                  {moment
                                    .utc(item.booking_date)
                                    .format("DD-MM-YYYY hh:mm a")}
                                  {/* {moment.utc(item.booking_date ? item.booking_date : item.createdDate).format("DD-MM-YYYY, h:mm a")} */}
                                </td>
                                <td>{`${item.customer_first_name || ""} ${item.customer_last_name || ""}`.trim()}</td>
                                <td>
                                  {item.configuration
                                    ? item.configuration
                                    : "-"}
                                </td>
                                <td>
                                  {" "}
                                  {item?.min_budget}
                                  {item.min_budget
                                    ? item.min_budget_type
                                    : null}
                                  {" - "}
                                  {item?.max_budget}
                                  {item.max_budget
                                    ? item.max_budget_type
                                    : null}
                                </td>
                                <td
                                  style={{
                                    color:
                                      bookingStatusColor[item?.booking_status],
                                    fontWeight: "600",
                                  }}
                                >
                                  {bookingStatus[item?.booking_status]}
                                </td>

                                {view && (
                                  <td className="p-2">
                                    <i
                                      className="fa fa-eye theme-fa-icon mr-3"
                                      aria-hidden="true"
                                      title="View Booking"
                                      onClick={() => {
                                        navigatpage(
                                          `/view_booking/${item._id}`
                                        );
                                      }}
                                    ></i>
                                  </td>
                                )}
                              </tr>
                            );
                          })
                        ) : (
                          <tr />
                        )}
                      </tbody>
                    </table>
                    <TableDataNotFound data={bookingList} />
                  </div>
                  <Pagination
                    totalCount={bookingListSelector?.response?.total_data}
                    listData={bookingList}
                    onPageChange={handlePageClick}
                    itemOffset={page}
                    setItemOffset={setPage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CancelBookingList;
